<div class="voucher-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <img class="icon" src="assets/images/menu/svg/vouchers.svg"><span class="title">Voucher</span>
        </div>

        <div class="page-actions">
            @if(permission.can_add){
            <button mat-button color="primary" class="btn-add"
                (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button>
            }
            @if(permission.can_export || permission.can_execute){
            <button mat-button color="accent" class="btn-export" (click)="exportClicked()" [disabled]="IsDownloading">
                <img class="download-icon"
                    [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                Export
            </button>
            }
        </div>
    </div>

    <div class="data-container">
        <app-loader [show]="isLoading"></app-loader>
        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
            [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
        </app-search-filter>
        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef (click)="sortData($event)" class="item-header">#</th>
                    <td mat-cell *matCellDef="let voucher; let i = index" class="item-column">{{
                        (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-sort-header="code" mat-header-cell style="width: 100px;" *matHeaderCellDef
                        (click)="sortData($event)">Code</th>
                    <td mat-cell *matCellDef="let voucher" style="width: 100px;">
                        {{voucher.code}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-sort-header="name" mat-header-cell *matHeaderCellDef (click)="sortData($event)">Name</th>
                    <td mat-cell *matCellDef="let voucher">{{voucher.name}}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-sort-header="description" mat-header-cell *matHeaderCellDef (click)="sortData($event)">
                        Description</th>
                    <td mat-cell *matCellDef="let voucher">{{voucher.description}}</td>
                </ng-container>

                <ng-container matColumnDef="voucher_type">
                    <th mat-sort-header="voucher_type" mat-header-cell style="width: 140px;" *matHeaderCellDef
                        (click)="sortData($event)">Voucher Type</th>
                    <td mat-cell *matCellDef="let voucher" style="width: 140px;">
                        {{voucher.voucher_type == 1 ? "St. Pierre's" : voucher.voucher_type}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="value">
                    <th mat-sort-header="value" mat-header-cell style="width: 120px;" *matHeaderCellDef
                        (click)="sortData($event)">Voucher Value</th>
                    <td mat-cell *matCellDef="let voucher" style="text-align: right; padding-right: 28px">
                        {{voucher.value | currency}}

                    </td>
                </ng-container>



                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let voucher">
                        <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                            (click)="onRowSelected(voucher);$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                        </a>

                        <mat-menu #rowMenu>
                            @if(permission.can_edit){
                            <button mat-menu-item (click)="onEdit(voucher)">
                                <mat-icon>edit</mat-icon>
                                <span>Edit</span>
                            </button>
                            }@else{
                            <button mat-menu-item (click)="onEdit(voucher)">
                                <mat-icon>edit</mat-icon>
                                <span>View</span>
                            </button>
                            }
                            @if(permission.can_delete){
                            <button mat-menu-item (click)="onDelete(voucher)">
                                <mat-icon>delete</mat-icon>
                                <span>Delete</span>
                            </button>
                            }
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let voucher; columns: displayedColumns;"
                    (click)="onRowSelected(voucher)" (dblclick)="onEdit(voucher)"
                    [ngClass]="{'row-selected' : voucher.id === selectedItem?.id}">
                </tr>
            </table>
        </section>

        @if(pagingData.length <= 0) { <div class="no-data-container">
            <img src="assets/images/no-data.png">
            <span class="no-data-info">No vouchers found. Please remove or redefine the filters if any.</span>
    </div>
    }
</div>
</div>

<!-- Uncomment when you create voucher summary component -->
<!-- <app-voucher-summary [voucher]="selectedItem" (onEdit)="onEdit($event)"
        (onDelete)="onDelete($event)"></app-voucher-summary> -->